var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4572 50.8609C41.1103 45.8458 44.5219 42.1389 48.3451 42.1389H61.0888C66.5626 42.1389 71 49.1577 71 57.8161V61.3359C71 63.6033 69.8379 65.441 68.4047 65.441H44.9009",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7124 40.4405C60.1603 40.4405 64.5767 36.013 64.5767 30.5513C64.5767 25.0897 60.1603 20.6621 54.7124 20.6621C49.2645 20.6621 44.8481 25.0897 44.8481 30.5513C44.8481 36.013 49.2645 40.4405 54.7124 40.4405Z",
    fill: "#FDA56B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7124 20.6621V40.4405C60.1602 40.4405 64.5767 36.013 64.5767 30.5512C64.5767 25.0894 60.1604 20.6621 54.7124 20.6621Z",
    fill: "#E99660"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1175 42.1389H54.7124V65.441H68.4122C69.8415 65.441 71 63.603 71 61.3359V57.8161C71 49.1577 66.5755 42.1389 61.1175 42.1389Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1424 65.6684H1.58398C0.709099 65.6684 0 64.5487 0 63.1673V60.5446C0 50.5051 5.15447 42.3663 11.5127 42.3663H22.695C26.5547 42.3663 29.8999 45.8436 31.5428 50.9222",
    fill: "#242424"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7029 42.3663H16.0581V65.6684H26.1472L31.5428 50.9222C29.9015 45.8436 26.5591 42.3663 22.7029 42.3663Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0581 40.4405C21.506 40.4405 25.9224 36.013 25.9224 30.5513C25.9224 25.0897 21.506 20.6621 16.0581 20.6621C10.6102 20.6621 6.19385 25.0897 6.19385 30.5513C6.19385 36.013 10.6102 40.4405 16.0581 40.4405Z",
    fill: "#FDA56B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9959 20.6621C15.9783 20.6621 15.961 20.6633 15.9435 20.6635V40.4392C15.961 40.4392 15.9783 40.4405 15.9959 40.4405C21.4783 40.4405 25.9225 36.013 25.9225 30.5512C25.9225 25.0896 21.4783 20.6621 15.9959 20.6621Z",
    fill: "#E99660"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3021 27.1134C42.7292 27.1134 48.75 21.0439 48.75 13.5567C48.75 6.06955 42.7292 0 35.3021 0C27.875 0 21.8541 6.06955 21.8541 13.5567C21.8541 21.0439 27.875 27.1134 35.3021 27.1134Z",
    fill: "#FDA56B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.418 0V27.1134C42.7899 27.0598 48.75 21.012 48.75 13.5568C48.75 6.10158 42.7899 0.0536173 35.418 0Z",
    fill: "#E99660"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2678 71H15.7324C14.3442 71 13.219 69.1528 13.219 66.8745V56.9475C13.219 44.26 19.4851 33.9746 27.2146 33.9746H43.7854C51.5149 33.9746 57.781 44.26 57.781 56.9475V66.8745C57.7812 69.1528 56.6558 71 55.2678 71Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8006 33.9746H35.6224V71H55.2704C56.657 71 57.781 69.1528 57.781 66.8745V56.9475C57.781 44.26 51.5217 33.9746 43.8006 33.9746Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.3aace4103b1b1e1488805afe2ed660dc.svg";
export { ForwardRef as ReactComponent };